
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addUnderscoreDash'
})
export class AddUnderscoreAndDash implements PipeTransform {
    transform(value: string, sign: string) {
        if (!value) {
            return value;
        }
        return value.replace(/\s+/g, sign);
    }
}
